<template>
  <v-row class="my-2 d-flex align-center">
    <v-col cols="6" md="4">
      <v-skeleton-loader type="text" v-if="$store.state.loading"></v-skeleton-loader>
      <v-text-field v-else label="Rechercher un coureur" density="compact" hide-details v-model="search" color="secondary"></v-text-field>
    </v-col>

    <v-col cols="6" md="4">
      <v-btn-toggle v-if="!$store.state.loading" v-model="selected_sexe" class="bordered" density="compact" color="secondary" variant="elevated" size="small">
        <v-btn value="Tous" size="small" density="compact">
          <v-icon icon="mdi-human-male-female"></v-icon>
        </v-btn>

        <v-btn value="M" size="small" density="compact">
          <v-icon icon="mdi-human-male"></v-icon>
        </v-btn>

        <v-btn value="F" size="small" density="compact">
          <v-icon icon="mdi-human-female"></v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["hide_challenge"],
  data() {
    return {
      search: "",
      selected_sexe: "Tous",
      selected_challenge: "Tous",
    };
  },
  watch: {
    selected_challenge() {
      this.$emit("onChangeFilters", { challenge: this.selected_challenge, sexe: this.selected_sexe, search: this.search });
    },
    selected_sexe() {
      this.$emit("onChangeFilters", { challenge: this.selected_challenge, sexe: this.selected_sexe, search: this.search });
    },
    search() {
      this.$emit("onChangeFilters", { challenge: this.selected_challenge, sexe: this.selected_sexe, search: this.search });
    },
  },
  computed: {
    items_challenge() {
      return [
        {
          title: "Tous",
          value: "Tous",
        },
        {
          title: "1 boucle",
          value: "Challenge 1 boucles",
        },
        {
          title: "3 boucles",
          value: "Challenge 3 boucles",
        },
        {
          title: "6 boucles",
          value: "Challenge 6 boucles",
        },
        {
          title: "Infinity",
          value: "Infinity",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>